<div>
  <mat-table
    #table
    matSort
    (matSortChange)="onSort.emit($event)"
    [matSortActive]="sortActive"
    [matSortDirection]="sortDirection"
    [dataSource]="dataSource"
    [class.no-dividers]="!dividers"
  >
    @for (column of columns; track column) {
      <ng-container [cdkColumnDef]="column.key">
        @switch (column.sortable) {
          @case (true) {
            <mat-header-cell
              mat-sort-header
              [style.max-width]="column.maxWidth"
              [style.min-width]="column.minWidth"
              *cdkHeaderCellDef
              >{{ column.title }}</mat-header-cell
            >
          }
          @default {
            <mat-header-cell
              [style.max-width]="column.maxWidth"
              [style.min-width]="column.minWidth"
              *cdkHeaderCellDef
              >{{ column.title }}</mat-header-cell
            >
          }
        }
        <mat-cell
          *cdkCellDef="let row"
          [style.max-width]="column.maxWidth"
          [style.min-width]="column.minWidth"
        >
          <ng-container
            [dataListCellPlaceholder]="column.key"
            [payload]="row"
          ></ng-container>
        </mat-cell>
      </ng-container>
    }
    @if (headings) {
      <mat-header-row *cdkHeaderRowDef="displayedColumns"></mat-header-row>
    }
    @if (link) {
      <a
        *cdkRowDef="let row; columns: displayedColumns"
        (click)="routeToItem(row.id)"
      >
        <mat-row></mat-row>
      </a>
    }
    @if (!link) {
      <mat-row
        *cdkRowDef="let row; columns: displayedColumns"
        (click)="rowClicked.next(row)"
        [class.hover:bg-gray-50]="highlightHover"
      ></mat-row>
    }
  </mat-table>
  @if (page && paginator) {
    <mat-paginator
      (page)="onPage.emit($event)"
      [length]="page.length"
      [pageIndex]="page.pageIndex"
      [pageSize]="page.pageSize"
      [pageSizeOptions]="[5, 10, 25, 100]"
    >
    </mat-paginator>
  }
</div>
